import messageResource from '../messageResource'

export const isEnabled = (features, feature) => features[feature] === true

export const getFeaturesChangesMessage = (featuresChanges) => {
    return Object.keys(featuresChanges).reduce((msg, feature) => {
        const featureTitle = messageResource.getMessage(`features.${feature}.title`)
        let msgKey = featuresChanges[feature] ? 'common.admin_enabled_functionality' : 'common.admin_disabled_functionality'
        return msg.concat(messageResource.getMessage(msgKey, [featureTitle]))
    }, '')
}


// WEBPACK FOOTER //
// ./web/js/features/utils.js